const CollegeIcon = ({ size = 24, color = 'currentColor', className = '' }) => (
  <svg aria-hidden="true"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    className={className}
  >
    <path d="M3 10l9-6 9 6" />
    <path d="M4 10v10h16V10" />
  </svg>
);

export default CollegeIcon;
